document.addEventListener("DOMContentLoaded", function () {


  const selector = document.querySelector(
    "[data-tb-region-selector]"
  );


  if (!selector) return;



  /*
  =================================
  Store Config
  =================================
  */


  const STORES = {


    US: {

      code: "US",

      domain:
      "https://www.touchbeauty.com",

      name:
      "US",

      currency:
      "USD $",

      flag:
      "tb-flag-us"

    },


    UK: {

      code: "UK",

      domain:
      "https://touchbeauty.uk",

      name:
      "UK",

      currency:
      "GBP £",

      flag:
      "tb-flag-uk"

    },


    JP: {

      code: "JP",

      domain:
      "https://www.touchbeauty.co.jp",

      name:
      "Japan",

      currency:
      "JPY ¥",

      flag:
      "tb-flag-jp"

    }


  };




  /*
  =================================
  Detect Current Store
  =================================
  */


  const hostname =
  window.location.hostname;


  let currentRegion =
  "US";


  if(
    hostname.includes("touchbeauty.uk")
  ){

    currentRegion =
    "UK";

  }


  if(
    hostname.includes("touchbeauty.co.jp")
  ){

    currentRegion =
    "JP";

  }





  /*
  =================================
  Update Header Display
  =================================
  */


  const flag =
  selector.querySelector(
    "[data-tb-current-flag]"
  );


  const region =
  selector.querySelector(
    "[data-tb-current-region]"
  );


  const currency =
  selector.querySelector(
    "[data-tb-current-currency]"
  );



  function updateRegionDisplay(code){


    const store =
    STORES[code];


    if(!store) return;



    if(region){

      region.textContent =
      store.name;

    }



    if(currency){

      currency.textContent =
      store.currency;

    }



    if(flag){

      flag.className =
      "tb-current-flag " +
      store.flag;

    }


  }



  updateRegionDisplay(
    currentRegion
  );






  /*
  =================================
  URL Builder
  Keep pathname + query + UTM
  =================================
  */


  function buildTargetUrl(store){


    return (

      store.domain +

      window.location.pathname +

      window.location.search

    );


  }





  /*
  =================================
  Cart Check
  =================================
  */


  async function hasCart(){


    try{


      const response =
      await fetch(
        "/cart.js",
        {
          credentials:
          "same-origin"
        }
      );


      const cart =
      await response.json();


      return (
        cart.item_count > 0
      );


    }catch(error){


      return false;


    }


  }





  /*
  =================================
  Save Region
  =================================
  */


  function saveRegion(region){


    const data = {

      region:
      region,


      timestamp:
      Date.now()

    };


    localStorage.setItem(

      "tb_selected_region",

      JSON.stringify(data)

    );


  }






  /*
  =================================
  Switch Store
  =================================
  */


  async function switchStore(regionCode){


    const store =
    STORES[regionCode];


    if(!store) return;



    const cart =
    await hasCart();



    if(cart){


      const confirmSwitch =
      window.confirm(

        "Your cart will not be transferred when switching stores. Continue?"

      );


      if(!confirmSwitch){

        return;

      }


    }



    saveRegion(
      regionCode
    );



    window.location.href =
    buildTargetUrl(store);



  }







  /*
  =================================
  Dropdown
  =================================
  */


  const button =
  selector.querySelector(
    ".tb-region-selector__button"
  );


  const menu =
  selector.querySelector(
    ".tb-region-selector__menu"
  );



  if(!button || !menu) return;




  button.addEventListener(
    "click",
    function(e){


      e.preventDefault();


      const opened =
      button.getAttribute(
        "aria-expanded"
      ) === "true";



      button.setAttribute(
        "aria-expanded",
        !opened
      );



      menu.hidden =
      opened;


    }
  );







  /*
  =================================
  Region Click
  =================================
  */


  const items =
  selector.querySelectorAll(
    ".tb-region-item"
  );



  items.forEach(function(item){


    item.addEventListener(
      "click",
      function(e){


        e.preventDefault();


        const region =
        item.dataset.region;



        switchStore(
          region
        );


      }
    );


  });







  /*
  =================================
  Click Outside
  =================================
  */


  document.addEventListener(
    "click",
    function(e){


      if(
        !selector.contains(
          e.target
        )
      ){


        menu.hidden =
        true;


        button.setAttribute(
          "aria-expanded",
          "false"
        );


      }


    }
  );



});